<template>
    <Modal :title="$t('identityChangedPopup.title')">
        <template #content>
            {{ isAnonymous ? $t('identityChangedPopup.messageName') : $t('identityChangedPopup.messageAnonymous') }}
            <br />
            <br />
            {{ $t('identityChangedPopup.question') }}
        </template>

        <template #actions>
            <!-- native modifier has been removed, please confirm whether the function has been affected  -->
            <BtnCta
                variant="secondary"
                @click="() => close(false)"
            >
                <div class="flex items-center gap-x-3">
                    <UserAvatar
                        class="-m-1"
                        size="xs"
                        :picture="profileImage"
                        :is-anonymous="isAnonymous"
                        :animated-avatar="gamifyAvatar"
                    />
                    <span>{{
                        isAnonymous
                            ? $t('identityChangedPopup.buttonStayAnonymous')
                            : $t('identityChangedPopup.buttonShowName')
                    }}</span>
                </div>
            </BtnCta>
            <!-- native modifier has been removed, please confirm whether the function has been affected  -->
            <BtnCta @click="() => close(true)">
                <div class="flex items-center gap-x-3">
                    <UserAvatar
                        class="-m-1"
                        size="xs"
                        :is-anonymous="!isAnonymous"
                        :picture="profileImage"
                        :animated-avatar="gamifyAvatar"
                    />
                    <span>{{
                        isAnonymous
                            ? $t('identityChangedPopup.buttonShowName')
                            : $t('identityChangedPopup.buttonBeAnonymous')
                    }}</span>
                </div>
            </BtnCta>
        </template>
    </Modal>
</template>

<script>
import Modal from '@components/Modal';
import ModalMixin from '@mixins/modalMixin';

export default {
    name: 'ModalConfirmPostIdentityChange',
    extends: ModalMixin,
    i18nOptions: {
        namespaces: ['post'],
    },
    props: {
        isAnonymous: {
            type: Boolean,
            default: false,
        },
        profileImage: {
            type: String,
            required: true,
        },
        gamifyAvatar: {
            type: String,
            default: null,
        },
    },
};
</script>
